import { useEffect, useState } from "react";
import { CalendarDays, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate, fmtDateTime } from "@/lib/format";
import { PageHeader, Loading, Empty } from "@/components/common";

export default function MyRaces() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/participations/mine").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <Loading />;
  return (
    <div>
      <PageHeader eyebrow="Area personale" title="Le mie gare" subtitle="Le manifestazioni a cui la tua partecipazione è stata registrata dagli organizzatori." />
      {rows.length === 0 ? <Empty>Non risultano ancora partecipazioni registrate.</Empty> : (
        <div className="grid gap-3 md:grid-cols-2" data-testid="my-races-list">
          {rows.map((p) => (
            <div key={p.id} className="card-surface p-5" data-testid={`my-race-${p.id}`}>
              <div className="font-mono text-xs text-slate-500">{p.event_code}</div>
              <div className="mt-1 font-display text-lg font-semibold text-slate-900">{p.event_name}</div>
              <div className="mt-2 space-y-1 text-sm text-slate-600">
                <div className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-slate-400" />{fmtDate(p.start_date)}</div>
                <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-slate-400" />{p.location || "—"}</div>
              </div>
              <div className="mt-3 text-sm"><b>{p.discipline}</b> · {(p.categories || []).join(", ")}</div>
              <div className="mt-1 text-xs text-slate-500">Licenza {p.license_number} · registrata il {fmtDateTime(p.registered_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
